import { HttpClient } from '@/data/protocols/http'
import { RemoteAccountProfile } from '@/data/usecases'
import { Account } from '@/domain/usecases'
import { QueryClient } from 'react-query'
import { makeApiV2Url, makeHttpAuthClient } from '../../http'

export const makeRemoteAccountProfile = (queryClient: QueryClient): Account => {
  return new RemoteAccountProfile(
    queryClient,
    makeApiV2Url('/user/account'),
    makeHttpAuthClient() as HttpClient<RemoteAccountProfile.Model>
  )
}
